import styled from 'styled-components';

import errorGraphic from '../../assets/svg/404-error-page.svg';

const NotFoundContainer = () => {
  const Graphic = styled.img``;

  return (
    <div>
      <h1 className="mb-4">Page Not Found</h1>
      <Graphic src={errorGraphic} alt="404 error page not found" />
    </div>
  );
};

export default NotFoundContainer;
